// Grey gender-aware placeholder avatar (clearly not a real photo).
export function Silhouette({ gender, size = 44, className = "" }) {
  const common = { width: size, height: size, viewBox: "0 0 64 64", fill: "currentColor", className };
  if (gender === "female") {
    return (
      <svg {...common} data-testid="silhouette-female" aria-label="Žena (bez fotografie)">
        <path d="M32 8c-7 0-12 5-12 12 0 3 1 6 3 8-4 1-6 3-6 6 0 0 4-2 6-2-2 3-3 6-3 9h24c0-3-1-6-3-9 2 0 6 2 6 2 0-3-2-5-6-6 2-2 3-5 3-8 0-7-5-12-12-12z" />
        <path d="M14 60c0-9 8-14 18-14s18 5 18 14z" />
      </svg>
    );
  }
  if (gender === "male") {
    return (
      <svg {...common} data-testid="silhouette-male" aria-label="Muž (bez fotografie)">
        <circle cx="32" cy="22" r="12" />
        <path d="M12 60c0-11 9-18 20-18s20 7 20 18z" />
      </svg>
    );
  }
  return (
    <svg {...common} data-testid="silhouette-neutral" aria-label="Bez fotografie">
      <circle cx="32" cy="23" r="11" />
      <path d="M14 58c0-10 8-16 18-16s18 6 18 16z" />
    </svg>
  );
}
